import {
	CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE,
	REFRESH_EDITOR_CONTENT_EXPERIENCE,
	collectAll,
} from '@confluence/experience-tracker';

export const collectCreateContentExperiences = (events, experience) => {
	collectAll([CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE])(events, experience);
};

export const collectUpdateContentExperiences = (events, experience) => {
	collectAll([CREATE_CONTENT_FROM_TEMPLATE_EXPERIENCE, REFRESH_EDITOR_CONTENT_EXPERIENCE])(
		events,
		experience,
	);
};
